/**
 * Cover cell <-> picture pixel mapping. The cover is size×size blocks over a (usually 32×32)
 * picture, so a cell owns a rectangle of pixels. Boundaries use floor(i * picSize / size), the same
 * rule as `paintPicture` in @kit/guess, so the guess card and the board always agree.
 */

/** Pixel indices (y * picSize + x) owned by every cell, row-major over the cover. */
export function cellPixels(size: number, picSize: number): number[][] {
  const edge = (i: number) => Math.floor((i * picSize) / size);
  const out: number[][] = [];
  for (let r = 0; r < size; r++)
    for (let c = 0; c < size; c++) {
      const px: number[] = [];
      for (let y = edge(r); y < edge(r + 1); y++) for (let x = edge(c); x < edge(c + 1); x++) px.push(y * picSize + x);
      out.push(px);
    }
  return out;
}

/** Cell index that owns picture pixel (x, y). */
export function pixelCell(size: number, picSize: number, x: number, y: number): number {
  const find = (v: number) => {
    let i = Math.min(size - 1, Math.floor((v * size) / picSize));
    while (i > 0 && Math.floor((i * picSize) / size) > v) i--;
    while (i < size - 1 && Math.floor(((i + 1) * picSize) / size) <= v) i++;
    return i;
  };
  return find(y) * size + find(x);
}

/** Which cells are open (cleared) right now. */
export function openMask(cover: ArrayLike<number>): boolean[] {
  const out = new Array<boolean>(cover.length);
  for (let i = 0; i < cover.length; i++) out[i] = cover[i]! < 0;
  return out;
}
